<template>
  <div>
    <NavBar />
    <b-overlay :show="loading" opacity="0.99">
      <b-container class="shadow rounded p-5 mt-5">
        <label-required-field label="password" />
        <input
          type="text"
          class="form-control"
          v-model="password"
          @input="handleChangePassword"
        />
        <b-form @submit.prevent="execute" v-if="isValidPassword">
          <div class="row mt-5">
            <div class="col-md-6 pt-0 pb-0">
              <label-required-field label="baseURL_assinar_pdf" />
              <input
                type="text"
                class="form-control"
                v-model="baseURL_assinar_pdf"
              />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label-required-field label="baseURL_token" />
              <input type="text" class="form-control" v-model="baseURL_token" />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label-required-field label="token_grant_type" />
              <input
                type="text"
                class="form-control"
                v-model="token_grant_type"
              />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label-required-field label="token_client_id" />
              <input
                type="text"
                class="form-control"
                v-model="token_client_id"
              />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label-required-field label="token_client_secret" />
              <input
                type="text"
                class="form-control"
                v-model="token_client_secret"
              />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label-required-field label="baseURL_kms" />
              <input type="text" class="form-control" v-model="baseURL_kms" />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label-required-field label="baseURL_hub" />
              <input type="text" class="form-control" v-model="baseURL_hub" />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label-required-field label="uuid_compartimento" />
              <input
                type="text"
                class="form-control"
                v-model="uuid_compartimento"
              />
            </div>
            <div class="col-md-6 pt-0 pb-0">
              <label-required-field label="baseURL_add_metadata" />
              <input
                type="text"
                class="form-control"
                v-model="baseURL_add_metadata"
              />
            </div>
            <div class="col-md-12">
              <errors-messages :errors="errors" />
            </div>
            <div class="col-md-12 pt-0 text-right">
              <v-btn
                :disabled="loading"
                :loading="loading"
                type="submit"
                class="v-success"
              >
                <i class="fa fa-check mr-1"></i> SALVAR
              </v-btn>
            </div>
          </div>
        </b-form>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import LabelRequiredField from "../templates/components/LabelRequiredField.vue";

import ErrorsMessages from "../templates/components/ErrorsMessages.vue";

import api from "../services/api";

import toast from "../components/ToastNotification";

export default {
  name: "ConfigCertificate",

  components: {
    NavBar,
    ErrorsMessages,
    LabelRequiredField,
  },

  data() {
    return {
      loading: false,

      baseURL_assinar_pdf: "",
      baseURL_token: "",
      token_grant_type: "",
      token_client_id: "",
      token_client_secret: "",
      baseURL_kms: "",
      baseURL_hub: "",
      uuid_compartimento: "",
      baseURL_add_metadata: "",

      password: "",
      isValidPassword: false,

      errors: [],
    };
  },

  async created() {
    await this.get();
  },

  methods: {
    handleChangePassword() {
      let { password } = this;

      this.isValidPassword = false;
      if (password == "config-certificate-execute") {
        this.isValidPassword = true;
      }
    },

    async get() {
      try {
        this.loading = true;

        const response = await api.get("/config-certificate");

        const { data } = response.data;

        if (data) {
          this.baseURL_assinar_pdf = data.baseURL_assinar_pdf;
          this.baseURL_token = data.baseURL_token;
          this.token_grant_type = data.token_grant_type;
          this.token_client_id = data.token_client_id;
          this.token_client_secret = data.token_client_secret;
          this.baseURL_kms = data.baseURL_kms;
          this.baseURL_hub = data.baseURL_hub;
          this.uuid_compartimento = data.uuid_compartimento;
          this.baseURL_add_metadata = data.baseURL_add_metadata;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loading = true;

        let {
          baseURL_assinar_pdf,
          baseURL_token,
          token_grant_type,
          token_client_id,
          token_client_secret,
          baseURL_kms,
          baseURL_hub,
          uuid_compartimento,
          baseURL_add_metadata,
        } = this;

        let params = {
          baseURL_assinar_pdf,
          baseURL_token,
          token_grant_type,
          token_client_id,
          token_client_secret,
          baseURL_kms,
          baseURL_hub,
          uuid_compartimento,
          baseURL_add_metadata,
        };

        let response = await api.post("/config-certificate", params);

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.get();
          this.errors = [];
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>